import React, { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import ContentStackedList from "components/DesignSystem/ContentStackedList";
import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import { AppContext } from "context/App";
import { useHistory } from "react-router-dom";
import EmptyState from "components/DesignSystem/EmptyState";

export default function RecentScreen() {
    const { setCurrentNav } = useContext(AppContext);
    const history = useHistory();

    const recentItems = useSelector((state) => state.recentItems);

    const onSelect = (item) => {
        history.push(item.edit_url);
    };

    useEffect(() => {
        setCurrentNav("recent");
    }, [setCurrentNav]);

    return (
        <MainBlock>
            <p className="prose prose-sm mb-4">
                All items you've viewed or edited this session will appear here.
            </p>
            {recentItems.length ? (
                <ContentStackedList items={recentItems} onSelect={onSelect} />
            ) : (
                <div className="rounded-md bg-white p-4 shadow-sm">
                    <EmptyState />
                </div>
            )}
        </MainBlock>
    );
}
